// src/pages/Admin-Dashboard/delete-user-modal.jsx (or wherever it resides)
import React, { useState } from "react";
import { toast } from "react-toastify"; // Using react-toastify for consistency
import { FiTrash2, FiAlertTriangle } from "react-icons/fi"; // Added FiAlertTriangle
import { deleteUser } from "../../api/user-api";

const DeleteUserModal = ({ userId, setUsers, onDelete }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  // The onDelete prop from UserListPage handles the API call and parent state update (including stats)
  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      // Call the onDelete prop passed from UserListPage which handles the main deletion logic
      await onDelete(); 
      setIsOpen(false);
      // Note: toast.success is handled by the calling component (UserListPage) or should be inside onDelete
      // but keeping it here for immediate feedback if onDelete doesn't handle toast.
    } catch (err) {
      console.error("Delete failed in modal", err);
      toast.error("Failed to delete user");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      {/* 🟢 UPDATED: Button Styling for Table Action */}
      <button
        onClick={(e) => {
          e.stopPropagation(); // Stop row click navigation
          setIsOpen(true);
        }}
        className="text-red-600 hover:text-red-800 flex items-center text-sm px-3 py-1 rounded-full transition hover:bg-red-50"
        title="Delete User"
      >
        <FiTrash2 className="mr-1 h-4 w-4" /> Delete
      </button>

      {isOpen && (
        // 🟢 UPDATED: Modal Backdrop and Dialog Style
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 p-4 transition-opacity duration-300">
          <div 
            className="bg-white rounded-xl shadow-2xl max-w-lg w-full transform transition-all duration-300 scale-100"
            // Stop propagation to prevent backdrop clicks from being misinterpreted
            onClick={(e) => e.stopPropagation()} 
          >
            {/* Modal Header */}
            <div className="p-5 border-b border-gray-100 flex items-center gap-3">
                <FiAlertTriangle className="h-6 w-6 text-red-500" />
                <h2 className="text-xl font-semibold text-gray-800">Confirm Deletion</h2>
            </div>

            {/* Modal Body */}
            <div className="p-5">
              <p className="text-sm text-gray-600 mb-6">
                You are about to permanently delete this user account. 
                <br />This action cannot be undone. 
                 <br />
                Are you absolutely sure you want to proceed?
              </p>
            </div>

            {/* Modal Footer (Action Buttons) */}
            <div className="p-5 bg-gray-50 flex justify-end gap-3 rounded-b-xl">
              <button
                onClick={() => setIsOpen(false)}
                disabled={isDeleting}
                className="px-4 py-2 text-sm font-medium border border-gray-300 rounded-lg text-gray-700 bg-white hover:bg-gray-100 transition disabled:opacity-50"
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                disabled={isDeleting}
                className="px-4 py-2 text-sm font-medium rounded-lg text-white bg-red-600 hover:bg-red-700 transition shadow-md disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isDeleting ? "Deleting..." : "Yes, Delete User"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeleteUserModal;